import UserBalanceSimpleView from './UserBalanceSimpleView'

export default UserBalanceSimpleView
